// extracted by mini-css-extract-plugin
export default {"ubi":"UBI_ubi__obZIC","bold":"UBI_bold__CWun+","buttons":"UBI_buttons__Yp-NN","input":"UBI_input__U35T0"};